module.exports = __webpack_public_path__ + "img/florens3.6adcd43f.jpg";